import { CheckConfigQueryResponse } from '@/api/model-index';
import { AdminService } from '@/api/service-index';
import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AdminCheckConfigResolver  {

  constructor(protected adminService: AdminService) {
    //
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<CheckConfigQueryResponse[] | null> {
    return this.adminService.apiAdminCheckConfigGet().pipe(
        map(response => {
            console.log(response);
            return response;
        }),
        catchError(err => {
            console.log(err);
            return of(err);
        })
    )
  }
}
